import { styled } from '@mui/material/styles'
import { Button as Btn } from '@mui/material'
import { Link as Lnk } from 'react-router-dom'

export const Button = styled(Btn)((props) => `
  box-sizing: border-box;
  ${(props?.color === 'secondary' && props?.variant === 'outlined') && `color: ${props?.theme?.palette?.secondary?.color}`};
  ${(props?.color === 'light') && 'color: #000'};
  ${(props?.color === 'light') && 'outline: 1px solid #E7E7E7'};
  ${props?.minwidth === 'true' && 'min-width: 140px'};
  ${props?.fullwidth === 'true' && 'min-width: 100%'};
  
  @media (max-width: 1400px) {
    min-width:auto;
  }
`)

export const Link = styled(Lnk)(`
  text-decoration: none;
  & button {
    text-decoration: none;
  }
`)
